var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 9.99999C15.7002 10.3584 15.5634 10.7168 15.2902 10.9901L6.6906 19.5897C6.14356 20.1367 5.25662 20.1367 4.7098 19.5897C4.16298 19.0428 4.16298 18.1561 4.7098 17.609L12.3192 9.99999L4.71006 2.39096C4.16324 1.84391 4.16324 0.957243 4.71006 0.410465C5.25689 -0.136843 6.14382 -0.136843 6.69087 0.410465L15.2905 9.00988C15.5637 9.28329 15.7002 9.64169 15.7002 9.99999Z",
    fill: "#086D35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 20) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.089aa6239838fd7fdf25b9f04c2b842c.svg";
export { ForwardRef as ReactComponent };